import { make } from 'vuex-pathify'
import actions from './actions'
import gettersCustom from './getters'

const inistialState = () => ({
  shop: null,
  loading: true,
  paymentMethods: null
})

const state = inistialState()

const getters = {
  ...gettersCustom,
  ...make.getters(state)
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
